<template>
  <v-card>
    <v-toolbar dark color="primary" tile flat class="mb-5">
      <v-btn icon dark @click="close">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title>欠席確認・削除</v-toolbar-title>
    </v-toolbar>

    <div v-for="(absence, index) in chatsAbsence" :key="`${index}-absence`" class="mb-5">
      <v-card class="mx-5">
        <v-card-title> 日付：{{ absence.date }}</v-card-title>
        <v-card-subtitle class="mt-2">
          理由
        </v-card-subtitle>
        <template v-if="absence.absenceDetails">
          <v-card-text style="white-space:pre-wrap;">
            {{ showReason(absence.absenceDetails.reason) }}
          </v-card-text>
          <template v-if="absence.absenceDetails.comment">
            <v-card-subtitle>
              コメント
            </v-card-subtitle>
            <v-card-text style="white-space:pre-wrap;">
              {{ absence.absenceDetails.comment }}
            </v-card-text>
          </template>
        </template>

        <div class="d-flex justify-center pb-3">
          <v-card-actions>
            <v-btn color="error" depressed @click="isDeleteAbsence(absence)" variant="flat">
              削除
            </v-btn>
          </v-card-actions>
        </div>
        <v-divider></v-divider>
      </v-card>
    </div>

    <v-dialog v-model="deleteDialog" class="delete-absence-dialog">
      <v-card>
        <div class="d-flex justify-space-around pt-3 pb-3">
          <v-card-title class="headline lighten-2">削除しますか？</v-card-title>
        </div>
        <div class="d-flex justify-space-around pt-3 pb-3">
          <v-card-actions>
            <v-btn @click="() => (deleteDialog = false)" variant="text">
              キャンセル
            </v-btn>
            <v-btn
              color="error"
              class="ml-5"
              depressed
              @click="deleteAbsence()"
              :loading="deleteLoading"
              variant="flat"
            >
              削除
            </v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script lang="ts">
import Vue, { PropType, defineComponent } from 'vue';
import dayjs from 'dayjs';
import 'dayjs/locale/ja';
dayjs.locale('ja');
import rules from '@/service/ValidRules';

import { chatModule } from '@/store/dataModules/chatModule';
import { when } from '@/service/Switch';

// model
import { VForm } from '@/model/Vuetify/VForm';
import { AbsenceReason, AbsenceReasonType, NurseryAttendanceResponse } from 'chaild-api/lib';

interface DataType {
  deleteLoading: boolean;
  deleteDialog: boolean;
  absence: NurseryAttendanceResponse | null;
}

export default defineComponent({
  name: 'AbsenceModal',

  props: {
    chatsAbsence: {
      type: Array as PropType<NurseryAttendanceResponse[]>,
      default: [],
    },
    childId: {
      type: Number,
      default: NaN,
    },
    date: {
      type: Object as PropType<any>,
      default: {},
    },
    nurseryId: {
      type: Number,
      default: NaN,
    },
  },

  computed: {},

  data: (): DataType => ({
    deleteLoading: false,
    deleteDialog: false,
    absence: null,
  }),

  watch: {
    deleteDialog: {
      async handler(val: boolean) {
        if (!val) {
          this.absence = null;
        }
      },
      deep: true,
    },
  },

  methods: {
    showReason(reason: AbsenceReasonType | null): string {
      const temp = when(reason)
        .on(
          v => v === AbsenceReason.fever,
          () => '発熱'
        )
        .on(
          v => v === AbsenceReason.personal,
          () => '家庭の事情'
        )
        .on(
          v => v === AbsenceReason.infStrep,
          () => '溶連菌感染症'
        )
        .on(
          v => v === AbsenceReason.infMycoplasma,
          () => 'マイコプラズマ肺炎'
        )
        .on(
          v => v === AbsenceReason.infHFMD,
          () => '手足口病'
        )
        .on(
          v => v === AbsenceReason.infSlappedCheek,
          () => '伝染性紅斑（りんご病）'
        )
        .on(
          v => v === AbsenceReason.infStomach,
          () => 'ウイルス性胃腸炎（ノロ、ロタ、アデノ等）'
        )
        .on(
          v => v === AbsenceReason.infHerpangina,
          () => 'ヘルパンギーナ'
        )
        .on(
          v => v === AbsenceReason.infRS,
          () => 'RSウィルス感染症'
        )
        .on(
          v => v === AbsenceReason.infZoster,
          () => '帯状疱疹'
        )
        .on(
          v => v === AbsenceReason.infRoseola,
          () => '突発性発しん'
        )
        .on(
          v => v === AbsenceReason.infImpetigo,
          () => '伝染性膿痂疹（とびひ）'
        )
        .on(
          v => v === AbsenceReason.covid19,
          () => '新型コロナウイルス'
        )
        .on(
          v => v === AbsenceReason.infInfluenzaA,
          () => 'インフルエンザA型'
        )
        .on(
          v => v === AbsenceReason.infInfluenzaB,
          () => 'インフルエンザB型'
        )
        .on(
          v => v === AbsenceReason.others,
          () => 'その他'
        )
        .otherwise(() => '');
      return temp;
    },
    close() {
      this.$emit('close');
    },
    isDeleteAbsence(absence: NurseryAttendanceResponse) {
      this.absence = absence;
      this.deleteDialog = true;
    },
    async deleteAbsence() {
      try {
        this.deleteLoading = true;
        if (this.absence) {
          await chatModule.deleteChatsAbsence({
            childId: this.childId,
            date: this.absence.date,
          });
          this.$emit('posted');
        }
      } catch (e) {
        console.log(e);
      } finally {
        this.$emit('close');
        this.deleteLoading = false;
      }
    },
  },

  async mounted() {},
});
</script>
<style lang="scss" scoped>
.delete-absence-dialog {
  z-index: 20 !important;
}
</style>
